import dayjs from "dayjs";
import { useEffect, useState } from "react";
import styles from "./index.module.scss";
export const LiveTime = () => {
  const [timeStr, setTimestr] = useState(
    dayjs().format("YYYY年MM月DD日 HH:mm:ss")
  );
  useEffect(() => {
    const interID = setInterval(() => {
      setTimestr(dayjs().format("YYYY年MM月DD日 HH:mm:ss"));
    }, 1000);
    return () => {
      clearInterval(interID);
    };
  }, []);
  return <div className={styles.time}>{timeStr}</div>;
};
